import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const MOCK_OPERATIONS = [
  { id: 'OP-2025-041', type: 'Corn Planting', field: 'North Quarter', acres: 156, completed: 135.7, status: 'active', equipment: '8R 410 + 1795 Planter', operator: 'Jake Morrison', date: '2025-02-07', priority: 'high', product: 'DKC 62-08 Corn', rate: '34,000 seeds/ac' },
  { id: 'OP-2025-042', type: 'Field Spraying', field: 'West 80', acres: 80, completed: 42.3, status: 'active', equipment: 'Case 4440 Sprayer', operator: 'Tom Becker', date: '2025-02-07', priority: 'high', product: 'Roundup PowerMax 3', rate: '22 oz/ac' },
  { id: 'OP-2025-043', type: 'Tillage', field: 'East Bottoms', acres: 220, completed: 220, status: 'completed', equipment: '9RX 640', operator: 'Maria Santos', date: '2025-02-07', priority: 'medium', product: 'N/A', rate: 'N/A' },
  { id: 'OP-2025-044', type: 'Soil Sampling', field: 'River Field', acres: 160, completed: 89.2, status: 'active', equipment: 'Pickup + Probe', operator: 'Sam Hutchins', date: '2025-02-07', priority: 'medium', product: 'Grid Sampling 2.5ac', rate: 'N/A' },
  { id: 'OP-2025-045', type: 'Soybean Planting', field: 'South 160', acres: 160, completed: 0, status: 'scheduled', equipment: '8R 370 + DB60', operator: 'TBD', date: '2025-02-07', priority: 'medium', product: 'AG36X6 Soybeans', rate: '140,000 seeds/ac' },
  { id: 'OP-2025-038', type: 'Fertilizer Application', field: 'Hutch North', acres: 160, completed: 160, status: 'completed', equipment: 'Spreader Truck', operator: 'Mike Dunn', date: '2025-02-06', priority: 'high', product: 'Urea 46-0-0', rate: '200 lbs/ac' },
  { id: 'OP-2025-039', type: 'Corn Planting', field: 'Hutch West', acres: 160, completed: 48, status: 'paused', equipment: '8R 370 + DB60', operator: 'Ryan Cole', date: '2025-02-06', priority: 'high', product: 'P0574AM Corn', rate: '32,000 seeds/ac' },
  { id: 'OP-2025-035', type: 'Field Spraying', field: 'East Bottoms', acres: 220, completed: 220, status: 'completed', equipment: 'Case 4440 Sprayer', operator: 'Tom Becker', date: '2025-02-05', priority: 'medium', product: 'Acuron Flexi', rate: '3 qt/ac' },
];

function OperationsPage() {
  const [operations] = useState(MOCK_OPERATIONS);
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => { /* Future: fetch from Supabase */ }, []);

  const getStatusBadge = (status) => {
    const map = { active: 'badge-success', completed: 'badge-default', scheduled: 'badge-warning', paused: 'badge-danger' };
    return map[status] || 'badge-default';
  };

  const getPriorityStyle = (p) => {
    const map = { high: { color: '#D9534F' }, medium: { color: '#FFDE00' }, low: { color: '#4A90D9' } };
    return map[p] || {};
  };

  const types = ['all', ...new Set(operations.map(o => o.type))];
  const filtered = operations.filter(o => {
    const matchStatus = filterStatus === 'all' || o.status === filterStatus;
    const matchType = filterType === 'all' || o.type === filterType;
    const matchSearch = !searchTerm || o.id.toLowerCase().includes(searchTerm.toLowerCase()) || o.field.toLowerCase().includes(searchTerm.toLowerCase());
    return matchStatus && matchType && matchSearch;
  });

  const thStyle = { padding: '10px 12px', fontSize: '0.75rem', textTransform: 'uppercase', opacity: 0.6 };
  const tdStyle = { padding: '10px 12px', fontSize: '0.85rem' };

  return (
    <div className="page-body">
      <div className="page-header">
        <div>
          <h1 style={{ margin: 0 }}>Operations</h1>
          <p style={{ margin: '4px 0 0', opacity: 0.7, fontSize: '0.85rem' }}>{operations.length} operations tracked</p>
        </div>
        <button className="btn btn-primary">+ New Operation</button>
      </div>

      <div style={{ display: "flex", gap: "12px", marginBottom: "16px", flexWrap: "wrap" }}>
        <input
          type="text"
          placeholder="Search by ID or field..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ padding: "8px 12px", borderRadius: "6px", border: "1px solid rgba(255,255,255,0.15)", background: "var(--surface)", color: "var(--text)", fontSize: "0.9rem", minWidth: "200px" }}
        />
        <button className={filterStatus === "all" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterStatus("all")}>All</button>
        <button className={filterStatus === "active" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterStatus("active")}>Active</button>
        <button className={filterStatus === "scheduled" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterStatus("scheduled")}>Scheduled</button>
        <button className={filterStatus === "completed" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterStatus("completed")}>Completed</button>
        <button className={filterStatus === "paused" ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterStatus("paused")}>Paused</button>
        <span style={{ borderLeft: '1px solid rgba(255,255,255,0.1)', margin: '0 4px' }} />
        {types.map(t => (
          <button key={t} className={filterType === t ? "btn btn-primary" : "btn btn-secondary"} onClick={() => setFilterType(t)} style={{ textTransform: "capitalize" }}>{t}</button>
        ))}
      </div>

      <div className="card">
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: "1px solid rgba(255,255,255,0.1)", textAlign: "left" }}>
                <th style={thStyle}>Op ID</th>
                <th style={thStyle}>Type</th>
                <th style={thStyle}>Field</th>
                <th style={thStyle}>Progress</th>
                <th style={thStyle}>Status</th>
                <th style={thStyle}>Priority</th>
                <th style={thStyle}>Equipment</th>
                <th style={thStyle}>Operator</th>
                <th style={thStyle}>Product / Rate</th>
                <th style={thStyle}>Date</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((op) => (
                <tr key={op.id} style={{ borderBottom: "1px solid rgba(255,255,255,0.05)", cursor: "pointer" }} onClick={() => window.location.hash = "#/operations/" + op.id}>
                  <td style={{ ...tdStyle, fontFamily: 'monospace' }}>{op.id}</td>
                  <td style={{ ...tdStyle, fontWeight: 600 }}>{op.type}</td>
                  <td style={tdStyle}>{op.field}</td>
                  <td style={tdStyle}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ width: "80px", height: "6px", background: "rgba(255,255,255,0.1)", borderRadius: "3px" }}>
                        <div style={{ width: Math.round((op.completed / op.acres) * 100) + "%", height: "100%", borderRadius: "3px", background: "#367C2B" }} />
                      </div>
                      <span style={{ fontSize: '0.8rem' }}>{Math.round((op.completed / op.acres) * 100)}%</span>
                    </div>
                  </td>
                  <td style={tdStyle}><span className={getStatusBadge(op.status)}>{op.status}</span></td>
                  <td style={tdStyle}><span style={{ ...getPriorityStyle(op.priority), textTransform: 'capitalize', fontWeight: 600 }}>{op.priority}</span></td>
                  <td style={tdStyle}>{op.equipment}</td>
                  <td style={tdStyle}>{op.operator}</td>
                  <td style={tdStyle}><div style={{ fontSize: '0.8rem' }}>{op.product}</div><div style={{ fontSize: '0.75rem', opacity: 0.5 }}>{op.rate}</div></td>
                  <td style={tdStyle}>{op.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default OperationsPage;